@if (title || description || (link?.length ?? 0) > 0) {
  <wp-inline-banner
        [attr.actionButton]="link && link.length > 0"
        [attr.action-button-text]="link?.[0]?.title"
        [attr.tone]="'info'"
        [closeButton]="false"
        (click)="onActionButtonClick($event)">
        <span slot="title">{{ title }}</span>
        <span slot="message">
          <p [innerHTML]="description"></p>
        </span>
      </wp-inline-banner>
}
